/**
 * @file Component representing the header of the application
 * @author Tom Verschoore de la Houssaije
 */
import { EventEmitter } from '@angular/core';
import { OnlineService } from '../../core/online.service';
import { NotificationsService } from '../../notifications/notifications.service';
import { OverlayService } from '../../core/overlay.service';
import { BrandingService } from '../../core/branding.service';
import { UserService } from '../../user.service';
import { AuthenticationService } from '../../authentication.service';
import { Router } from '@angular/router';
/**
 * Component representing the header of the application
 */
var HeaderComponent = /** @class */ (function () {
    /**
    * Creates an instance of HeaderComponent.
    * @param {UserService} userService
    * @param {ResourceService} resourceService
    * @param {RouterService} userService
    * @param {OnlineService} onlineService
    * @param {NotificationsService} notificationsService
    * @param {OverlayService} overlayService
    * @param {BrandingService} brandingService
    * @param {AuthenticationService} authenticationService
    * @memberof HeaderComponent
    */
    function HeaderComponent(userService, router, onlineService, notificationsService, overlayService, brandingService, authenticationService) {
        this.userService = userService;
        this.router = router;
        this.onlineService = onlineService;
        this.notificationsService = notificationsService;
        this.overlayService = overlayService;
        this.brandingService = brandingService;
        this.authenticationService = authenticationService;
        /** Event to notify the expanding and collapsing of the main application menu */
        this.menuToggled = new EventEmitter();
    }
    /**
     * Check if application is online
     */
    HeaderComponent.prototype.isOnline = function () {
        return this.onlineService.isOnline();
    };
    Object.defineProperty(HeaderComponent.prototype, "authenticated", {
        /** Gets a boolean value indicating whether or not the user is authenticated */
        get: function () {
            return this.authenticationService.hasValidAccessToken();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Perform log out from authentication service
     */
    HeaderComponent.prototype.doLogout = function (event) {
        event.stopPropagation();
        this.authenticationService.logOut();
        return false;
    };
    /**
     * Go to the first page of the webapplication
     */
    HeaderComponent.prototype.goToDefault = function () {
        this.router.navigateByUrl('/');
    };
    /**
     * Go to the the notifications
     */
    HeaderComponent.prototype.goToNotifications = function () {
        this.router.navigate(['notification/inbox']);
    };
    /**
     * Initiates the creation of the account overlay
     */
    HeaderComponent.prototype.openAccount = function () {
        this.overlayService.goToEntity(this.userService.user);
    };
    Object.defineProperty(HeaderComponent.prototype, "user", {
        /** Gets the user info of the logged in user */
        get: function () {
            return this.userService.user;
        },
        enumerable: true,
        configurable: true
    });
    /** Translate the HTML5 role into the correct localisation key */
    HeaderComponent.prototype.roleIntoLocalisationKey = function () {
        return 'APP.MISC.ROLES.' + this.user.HTML5Role.toUpperCase();
    };
    /**
     * This method is invoked when the user activates or deactivates the main application menu
     * @param event The HTML event triggered by the user
     */
    HeaderComponent.prototype.invokeMenuToggle = function (event) {
        event.cancelBubble = true;
        this.menuToggled.emit(event);
        // Trying not to reload page when used in a <a> element
        return false;
    };
    return HeaderComponent;
}());
export { HeaderComponent };
